<template>
  <div>
    <GmzHqsjfxTableList/>
  </div>
</template>

<script>
import GmzHqsjfxTableList from "@/components/gmzHqsjfxTable/GmzHqsjfxTableList";
export default {
  name: 'GmzHqsjfxTable',
  components: {GmzHqsjfxTableList},
  data() {
    return {
    }
  },
  methods:{
  }
}
</script>
